var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("IntermediateHeader"),
      _c("div", { staticClass: "out-padd bg-pickl" }, [
        _c(
          "section",
          {
            staticClass: "pricing-section side-padd",
            attrs: { id: "pricing" }
          },
          [
            _c("h3", [_vm._v("PICKL GROWS WITH YOUR BRAND")]),
            _c("div", { staticClass: "pricing-table" }, [
              _c(
                "div",
                { staticClass: "plan" },
                [
                  _vm._m(0),
                  _vm._m(1),
                  _vm._m(2),
                  _c("dir", [_vm._v("50 store checks, plus")]),
                  _vm._m(3)
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "plan" },
                [
                  _vm._m(4),
                  _vm._m(5),
                  _vm._m(6),
                  _c("dir", [_vm._v("All Basic perks, plus")]),
                  _vm._m(7)
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "plan featured" },
                [
                  _vm._m(8),
                  _vm._m(9),
                  _vm._m(10),
                  _vm._m(11),
                  _c("dir", [
                    _vm._v("75 store checks, all Essential perks plus")
                  ]),
                  _vm._m(12)
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "plan" },
                [
                  _c("div", { staticClass: "plan-header" }, [
                    _c("h4", { staticClass: "plan-title" }, [
                      _vm._v("VIP Enterprise")
                    ]),
                    _c("div", { staticClass: "plan-image" }, [
                      _c(
                        "svg",
                        {
                          staticStyle: {
                            "enable-background": "new 0 0 512 512"
                          },
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            version: "1.1",
                            id: "Layer_1",
                            x: "0px",
                            y: "0px",
                            viewBox: "0 0 512 512",
                            "xml:space": "preserve",
                            width: "75px",
                            height: "75px"
                          }
                        },
                        [
                          _c("path", {
                            attrs: {
                              d:
                                "M82.877,311.122c3.417,2.287,7.281,3.38,11.104,3.38c6.45,0,12.783-3.116,16.64-8.879  c32.317-48.292,86.34-77.123,144.511-77.123c57.999,0,111.933,28.699,144.273,76.77c6.167,9.165,18.594,11.596,27.758,5.43  c9.165-6.166,11.596-18.594,5.43-27.758c-25.839-38.406-62.885-66.745-105.219-81.905C352.762,180.298,369,148.761,369,113.5  c0-62.309-50.691-113-113-113s-113,50.691-113,113c0,35.008,16.002,66.347,41.076,87.091  c-42.996,15.104-80.599,43.786-106.698,82.786C71.235,292.557,73.697,304.979,82.877,311.122z M256,40.5c40.252,0,73,32.748,73,73  s-32.748,73-73,73s-73-32.748-73-73S215.748,40.5,256,40.5z M335.758,354.63l-29.816,21.509c-4.436,3.2-6.293,8.873-4.598,14.051  l12.007,34.802c0.507,1.55,0.702,3.064,0.637,4.508c-0.425,9.347-12.14,15.741-20.732,9.543l-29.815-21.515  c-2.218-1.6-4.829-2.4-7.44-2.4c-2.611,0-5.222,0.8-7.44,2.4l-29.815,21.515c-8.592,6.198-20.363-0.196-20.735-9.543  c-0.057-1.444,0.143-2.959,0.65-4.508l11.996-34.802c1.695-5.178-0.162-10.851-4.598-14.051l-29.816-21.509  c-9.92-7.156-4.822-24.13,7.44-24.13h36.854c5.484,0,10.344-2.111,12.038-7.289l11.388-35.027c1.895-5.789,6.966-8.684,12.038-8.684  c5.072,0,10.143,2.895,12.038,8.684l11.388,35.027c1.695,5.178,6.554,7.289,12.038,7.289h36.854  C340.58,330.5,345.678,347.474,335.758,354.63z M506.758,424.63l-29.816,21.509c-4.436,3.2-6.293,8.873-4.598,14.051l12.007,34.802  c0.507,1.55,0.702,3.064,0.637,4.508c-0.425,9.347-12.14,15.741-20.732,9.543l-29.815-21.515c-2.218-1.6-4.829-2.4-7.44-2.4  s-5.222,0.8-7.44,2.4l-29.815,21.515c-8.592,6.198-20.363-0.196-20.735-9.543c-0.057-1.444,0.143-2.959,0.65-4.508l11.996-34.802  c1.695-5.178-0.162-10.851-4.598-14.051l-29.816-21.509c-9.92-7.156-4.822-24.13,7.44-24.13h36.854  c5.484,0,10.344-2.111,12.038-7.289l11.388-35.027c1.895-5.789,6.966-8.684,12.038-8.684s10.143,2.895,12.038,8.684l11.388,35.027  c1.695,5.178,6.554,7.289,12.038,7.289h36.854C511.58,400.5,516.678,417.474,506.758,424.63z M164.758,424.63l-29.816,21.509  c-4.436,3.2-6.293,8.873-4.598,14.051l12.007,34.802c0.507,1.55,0.702,3.064,0.637,4.508c-0.425,9.347-12.14,15.741-20.732,9.543  L92.44,487.528c-2.218-1.6-4.829-2.4-7.44-2.4s-5.222,0.8-7.44,2.4l-29.815,21.515c-8.592,6.198-20.363-0.196-20.735-9.543  c-0.057-1.444,0.143-2.959,0.65-4.508l11.996-34.802c1.695-5.178-0.162-10.851-4.598-14.051L5.242,424.63  c-9.92-7.156-4.822-24.13,7.44-24.13h36.854c5.484,0,10.344-2.111,12.038-7.289l11.388-35.027c1.895-5.789,6.966-8.684,12.038-8.684  s10.143,2.895,12.038,8.684l11.388,35.027c1.695,5.178,6.554,7.289,12.038,7.289h36.854  C169.58,400.5,174.678,417.474,164.758,424.63z"
                            }
                          })
                        ]
                      )
                    ])
                  ]),
                  _vm._m(13),
                  _vm._m(14),
                  _c("dir", [_vm._v(">100 store checks, all Pro perks plus")]),
                  _vm._m(15)
                ],
                1
              )
            ])
          ]
        ),
        _c(
          "div",
          { staticStyle: { "text-align": "center" } },
          [
            _c("br"),
            _c(
              "router-link",
              {
                staticClass: "btn-lg-green",
                staticStyle: { width: "30%" },
                attrs: { to: "/brand/dashboard" }
              },
              [_vm._v("GO TO DASHBOARD")]
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "plan-header" }, [
      _c("h4", { staticClass: "plan-title" }, [_vm._v("Basic")]),
      _c("div", { staticClass: "plan-cost" }, [
        _c("span", { staticClass: "plan-price" }, [
          _c("span", { staticClass: "strikeout" }, [_vm._v("$18.50")]),
          _vm._v(" $14.99\n                    ")
        ]),
        _c("span", { staticClass: "plan-type" }, [
          _vm._v("/store check, 1-time monthly package")
        ]),
        _c("span", { staticClass: "plan-type" }, [
          _vm._v("INTRO SPECIAL 1-time offer")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "plan-details" }, [
      _c("p", [
        _vm._v("Everything you need to try PICKL and start gathering insights")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "plan-select" }, [
      _c(
        "a",
        {
          attrs: {
            href: "",
            "data-target": "#demo-popup",
            "data-toggle": "modal"
          }
        },
        [_vm._v("Start Now")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "plan-features" }, [
      _c("li", [_vm._v("Secure dashboard & your own 1st party data")]),
      _c("li", [_vm._v("2hr – 1 wk results")]),
      _c("li", [_vm._v("Shelf, display & marketing verification")]),
      _c("li", [_vm._v("Drive shoppers to stores & products")]),
      _c("li", [_vm._v("Research competition, packaging & placements")]),
      _c("li", [_vm._v("Automated store specific-location requests")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "plan-header" }, [
      _c("h4", { staticClass: "plan-title" }, [_vm._v("Essentials")]),
      _c("div", { staticClass: "plan-cost" }, [
        _c("span", { staticClass: "plan-price" }, [_vm._v("$14.99")]),
        _c("span", { staticClass: "plan-type" }, [
          _vm._v("/store check, billed monthly, annual contract")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "plan-details" }, [
      _c("p", [
        _vm._v(
          "Brand & Retailers with limited locations, doing research & expanding"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "plan-select" }, [
      _c(
        "a",
        {
          attrs: {
            href: "",
            "data-target": "#demo-popup",
            "data-toggle": "modal"
          }
        },
        [_vm._v("Start Now")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "plan-features" }, [
      _c("li", [_vm._v("Dedicated support")]),
      _c("li", [_vm._v("Curated 1-2 state expansion plans")]),
      _c("li", [_vm._v("Automated promo & pricing alerts")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "extra-info" }, [
      _c("h5", [_vm._v("Best Value")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "plan-header" }, [
      _c("h4", { staticClass: "plan-title" }, [
        _c("span", [
          _vm._v("\n                    Pro\n                    "),
          _c("img", { attrs: { src: "/img/pickl-logo.png" } })
        ])
      ]),
      _c("div", { staticClass: "plan-cost" }, [
        _c("span", { staticClass: "plan-price" }, [_vm._v("$12.99")]),
        _c("span", { staticClass: "plan-type" }, [
          _vm._v("/store check, billed monthly, annual contract")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "plan-details" }, [
      _c("p", [
        _vm._v(
          "Brands & retailers with national placement, deeper research & consistent insight"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "plan-select" }, [
      _c(
        "a",
        {
          attrs: {
            href: "",
            "data-target": "#demo-popup",
            "data-toggle": "modal"
          }
        },
        [_vm._v("Start Now")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "plan-features" }, [
      _c("li", [_vm._v("Dedicated feedback look")]),
      _c("li", [_vm._v("1st to new features")]),
      _c("li", [_vm._v("Curated 3-5 states expansion plans")]),
      _c("li", [_vm._v("Entice shoppers to purchase with new engagements")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "plan-details" }, [
      _c("p", [
        _vm._v(
          "Accepting limited Brands & Retailers. Curated features, protected categories & 1st to market features"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "plan-select" }, [
      _c(
        "a",
        {
          attrs: {
            href: "",
            "data-target": "#demo-popup",
            "data-toggle": "modal"
          }
        },
        [_vm._v("Contact Sales")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "plan-features" }, [
      _c("li", [_vm._v("Curated features")]),
      _c("li", [_vm._v("1st to market exclusives")]),
      _c("li", [_vm._v("Custom visualization features")]),
      _c("li", [_vm._v("Trend & correlation analytics")]),
      _c("li", [_vm._v("Shopper focus groups & surveys")]),
      _c("li", [_vm._v("Automated Reporting")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }